import React from 'react';

const CategoryModal = ({
  show,
  editingCategory,
  categoryForm,
  setCategoryForm,
  onSubmit,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-lg w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">
              {editingCategory ? 'Редактировать категорию' : 'Новая категория'}
            </h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">×</button>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ключ (латиница) *</label>
                <input
                  type="text"
                  value={categoryForm.key}
                  onChange={(e) => setCategoryForm({ ...categoryForm, key: e.target.value })}
                  required
                  placeholder="newCategory"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  disabled={!!editingCategory}
                  data-testid="category-key-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Порядок</label>
                <input
                  type="number"
                  value={categoryForm.order}
                  onChange={(e) => setCategoryForm({ ...categoryForm, order: parseInt(e.target.value) })}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  data-testid="category-order-input"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Название (RU) *</label>
              <input
                type="text"
                value={categoryForm.name_ru}
                onChange={(e) => setCategoryForm({ ...categoryForm, name_ru: e.target.value })}
                required
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid="category-name-ru-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Название (EN) *</label>
              <input
                type="text"
                value={categoryForm.name_en}
                onChange={(e) => setCategoryForm({ ...categoryForm, name_en: e.target.value })}
                required
                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid="category-name-en-input"
              />
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                checked={categoryForm.is_active}
                onChange={(e) => setCategoryForm({ ...categoryForm, is_active: e.target.checked })}
                className="w-4 h-4 text-blue-500"
                data-testid="category-is-active-checkbox"
              />
              <label className="ml-2 text-sm text-gray-700">Категория активна</label>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border rounded-lg"
                data-testid="category-cancel-btn"
              >
                Отмена
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                data-testid="category-submit-btn"
              >
                {editingCategory ? 'Сохранить' : 'Создать'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CategoryModal;
